import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";
import { validateTilDatoEfterEllerSammeSomFraDato } from "../../../util/validation";
import { format } from "date-fns";

export const adminUdvalgFormConfig = (id?: string): FormConfig<UdvalgDTO> => {
  return {
    title: "udvalg",
    lockedValues: [{ id: "id", value: id }],
    validationSchema: Yup.object({
      navn: Yup.string().required("Påkrævet"),
      periodeFraDato: Yup.date().nullable().required("Påkrævet"),
      periodeTilDatoInklusiv: Yup.date()
        .nullable()
        .test(
          "tilDato",
          "Slutdato kan ikke være før startdato",
          function (val) {
            const { periodeFraDato } = this.parent;
            return validateTilDatoEfterEllerSammeSomFraDato(
              periodeFraDato,
              val,
            );
          },
        ),
    }),

    form: [
      {
        component: "textinput",
        id: "navn",
        initialValue: "",
        label: "Navn",
        placeholder: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "beskrivelse",
        initialValue: "",
        label: "Beskrivelse",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        initialValue: "",
        label: "Periode fra dato",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        initialValue: "",
        label: "Periode til dato inklusiv",
        placeholder: "",
        isRequired: false,
      },
    ],
    get: `udvalg/${id}`,
    post(values) {
      const dto = {
        navn: values.navn,
        beskrivelse: values.beskrivelse,
        periodeFraDato: format(new Date(values.periodeFraDato), "yyyy-MM-dd"),
        periodeTilDatoInklusiv: values.periodeTilDatoInklusiv,
      };
      return {
        query: `udvalg`,
        body: dto,
        // body: values,
      };
    },
    patch(values) {
      return {
        query: `udvalg/${id}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
  };
};
